import { Box, Stack, FormControl, FormLabel, FormHelperText, CircularProgress } from '@mui/joy';
import { Controller, useFormContext } from 'react-hook-form';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ImageThumbnailCard } from '@/components/ImageThumbnailCard';
import { InputFileUpload } from '@/components/InputFileUpload';
import { IMAGE_UPLOAD_ACCEPT } from '@/utils/images';
import { extractUploadErrorMessage } from '@/utils/errors';

export function FormImage({ name, label, useUploadImageMutation }) {
  const { control, formState } = useFormContext();
  const error = formState.errors[name];
  const { householdId } = useParams();
  const [uploadImage, { isLoading: isUploading }] = useUploadImageMutation();
  const [uploadError, setUploadError] = useState('');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        async function handleFileUpload(event) {
          const file = event.target.files?.[0];
          event.target.value = '';
          if (!file || !householdId) return;

          setUploadError('');
          try {
            const result = await uploadImage({ householdId, file }).unwrap();
            field.onChange({ ...result.data, url: URL.createObjectURL(file) });
          } catch (err) {
            setUploadError(extractUploadErrorMessage(err));
          }
        }

        return (
          <FormControl error={!!error}>
            <FormLabel sx={{ mb: 0.75 }}>{label}</FormLabel>
            {field.value?.url && (
              <ImageThumbnailCard url={field.value.url} alt={label} onRemove={() => field.onChange(null)} sx={{ mb: 1 }} />
            )}
            <Stack direction="row" alignItems="center" gap={1}>
              <InputFileUpload
                title={isUploading ? 'Uploading...' : field.value?.url ? 'Replace Image' : 'Upload Image'}
                onChange={handleFileUpload}
                accept={IMAGE_UPLOAD_ACCEPT}
              />
              {isUploading && <CircularProgress size="sm" />}
            </Stack>
            {uploadError && <Box sx={{ mt: 1, color: 'danger.500', fontSize: 'sm' }}>{uploadError}</Box>}
            {error && <FormHelperText sx={{ mt: 1 }}>{error.message}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
}
